import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/index'
import Settle from '@/views/settle'
import Pay from '@/views/pay'
import PaySZF from '@/views/pay-szf'
import payJM from '@/views/pay-jm'
import Success from '@/views/success'
import BindCard from '@/views/bindCard'
import BindCardStep from '@/views/bindCard-step'
import AdminLogin from '@/views/admin/login'
import AdminExchange from '@/views/admin/exchange'
import OnlinePay from '@/views/szf/onlinePay'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/layout'
  },
  {
    path: '/layout/:username/:password',
    name: 'layout',
    component: Layout
  },
  {
    path: '/settle',
    name: 'settle',
    component: Settle
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay
  },
  {
    path: '/paySZF',
    name: 'paySZF',
    component: PaySZF
  },
  {
    path: '/payJM',
    name: 'payJM',
    component: payJM
  },
  {
    path: '/success',
    name: 'success',
    component: Success
  },
  {
    path: '/bindCard',
    name: 'bindCard',
    component: BindCard
  },
  {
    path: '/bindCardStep',
    name: 'bindCardStep',
    component: BindCardStep
  },
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: AdminLogin
  },
  {
    path: '/admin/exchange',
    name: 'adminExchange',
    component: AdminExchange
  },
  {
    path: '/szf/onlinePay',
    name: 'onlinePay',
    component: OnlinePay
  },
]

const router = new VueRouter({
  routes
})

export default router
